import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
  split,
  type DefaultOptions
} from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { GraphQLWsLink } from "@apollo/client/link/subscriptions"
import { getMainDefinition } from "@apollo/client/utilities"
import createUploadLink from "apollo-upload-client/createUploadLink.mjs"
import { createClient } from "graphql-ws"
import ReactDOM from "react-dom/client"

import App from "./App"

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("authToken")
  const language = localStorage.getItem("i18nextLng") || navigator.language

  if (!!token) {
    return {
      headers: {
        ...headers,
        authorization: token,
        language
      }
    }
  }

  return {
    headers: {
      ...headers,
      language
    }
  }
})

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
}
const API_URL = process.env.REACT_APP_API_URL as string
const wsUrl =
  (window.location.protocol.toString() === "https:" ? "wss://" : "ws://") +
  API_URL.split("http://").join("").split("https://").join("") +
  "/graphql"

const wsLink = new GraphQLWsLink(
  createClient({
    url: wsUrl,
    shouldRetry: () => true
  })
)

const httpLink = createUploadLink({
  uri: API_URL + "/graphql",
  headers: {
    "apollo-require-preflight": "true"
  }
})

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      definition.kind === "OperationDefinition" &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      definition.operation === "subscription"
    )
  },
  wsLink,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  httpLink
)

export const client = new ApolloClient({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  link: ApolloLink.from([authLink, splitLink]),
  cache: new InMemoryCache(),
  defaultOptions
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
)
